/**
 * Module-level "is a recording in progress" flag, for guards that live OUTSIDE
 * React (e.g. the `vite:preloadError` auto-reload in main.tsx). In-app navigation,
 * back/forward and reload/close are blocked via TanStack `useBlocker` in
 * RecordingControls; this covers the one auto-reload the blocker can't intercept.
 *
 * The flag is kept in sync by RecordingStateContext.setRecordingActive.
 */
let recording = false
let pendingReload = false

/** Sync the recording state (called from RecordingStateContext). */
export function setRecordingGuard(active: boolean): void {
  recording = active
  // A reload deferred during recording fires once the recording ends.
  if (!active && pendingReload) {
    pendingReload = false
    window.location.reload()
  }
}

/**
 * Reload the page, unless a recording is in progress — in which case defer it
 * until the recording ends (so a stale-chunk reload never kills a live capture).
 */
export function requestReload(): void {
  if (recording) {
    pendingReload = true
    return
  }
  window.location.reload()
}
